<template>
  <div
    :class="[
      'score-float',
      {
        editable: (is_admin || is_owner) && editable,
        audited: a.score_get === -1,
        active: a.right,
        red: !a.right
      }
    ]"
    @click="(is_admin || is_owner) && editable ? editScore() : ''"
    :data-item="a"
    :data-index="a.originIndex"
  >
    <img
      class="score-float-icon"
      :src="a.score_get === -1 ? auditedIcon : a.right ? rightIcon : wrongIcon"
      mode="aspectFill"
    />
    <template v-if="a.score_get === -1"
      >批改后出分</template
    >
    <template v-else>
      <span>{{ a.right ? "答对" : "答错" }} 得</span>
      <label class="score-float-input">{{ a.score_get }}</label>
      <span>分</span>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    a: {
      type: Object,
      default: {}
    },
    is_owner: {
      type: Number,
      default: 0
    },
    is_admin: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      editable: false,
      rightIcon:
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-04/716f21db42900bb102215d266cf68f2f.png",
      wrongIcon:
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-04/383c6d88369edf3e96a4867314715314.png",
      auditedIcon:
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-06-26/4bb4381543c9bca546fc5430846ac76e.png"
    };
  },
  methods: {
    editScore() {

    }
  }
};
</script>
<style lang="scss" scoped>
.score-float {
  display: inline-flex;
  background: rgba(255, 112, 112, 0.102);
  color: #ff7070;
  height: 29px;
  border-radius: 30px;
  align-items: center;
  padding: 0 10px;
  font-size: 13px;
}
.score-float.active {
  background: rgba(0, 207, 151, 0.102);
  color: #00cf97;
}
.score-float.audited {
  background: rgba(254, 153, 0, 0.1);
  color: #fe9900;
}
.score-float-icon {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}
.score-float-input {
  padding: 0 3px;
}
.editable.red .score-float-input {
  border-bottom: 1px solid red;
}
.editable.active .score-float-input {
  border-bottom: 1px solid #00cf97;
}
</style>



// WEBPACK FOOTER //
// src/components/common/scoreitem.vue